class c extends HTMLElement {
  constructor() {
    var e;
    super(), this.assetMap = JSON.parse(
      ((e = this.querySelector("script")) == null ? void 0 : e.textContent) || "{}"
    );
  }
  connectedCallback() {
    const e = this.parentNode;
    !e || !Object.keys(this.assetMap).length || (this.findCustomElements(e), this.observeMutations(e));
  }
  findCustomElements(e) {
    [e, ...Array.from(e.querySelectorAll("*"))].forEach((t) => {
      let s = t.localName;
      if (s.includes("-") && !customElements.get(s)) {
        const o = t.getAttribute("needs-script");
        o && (s = o), this.load(s);
      }
    });
  }
  observeMutations(e) {
    this.observer = new MutationObserver((r) => {
      r.forEach(({ addedNodes: t }) => {
        t.forEach((s) => {
          s.nodeType === Node.ELEMENT_NODE && this.findCustomElements(s);
        });
      });
    }), this.observer.observe(e, { childList: !0, subtree: !0 });
  }
  load(e) {
    const r = this.assetMap[e];
    if (!r || document.querySelector(`script[src="${r}"]`))
      return;
    const t = document.createElement("script");
    t.src = r, t.type = "module", document.body.appendChild(t);
  }
}
customElements.define("script-loader", c);
